export default __webpack_public_path__ + "static/media/Contrato-orange.968ecd7b.svg";